import React, { useState, useContext, useEffect } from 'react';
import { useStaticQuery, navigate } from 'gatsby';
import { VisuallyHidden } from '@chakra-ui/react';
import Spacer from '@interness/web-core/src/components/structure/Spacer/Spacer';
import Heading from '@interness/web-core/src/components/text/Heading/Heading';
import { findT } from '@interness/web-core/src/components/_helpers';
import Center from '@interness/web-core/src/components/structure/Center/Center';
import Filters from '../Filters/Filters';
import ProductGrid from '../ProudctGrid/ProductGrid';
import Pagination from '../Pagination/Pagination';
import { EApiContext } from '../../context/EApi';
import { StoreContext } from '../../context/Store';
// import FiltersSidebar   from '../Filters/FiltersSidebar';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Overview = _ref => {
  let {
    title,
    brandPageMode,
    tag
  } = _ref;
  // const [sidebarEnabled, setSidebarEnabled] = useState(false);
  const {
    settings
  } = useContext(EApiContext);
  const {
    storeRootPath
  } = useContext(StoreContext);
  // const { loading, data: settingsData, error } = settings;
  const {
    loading,
    error
  } = settings;
  const data = useStaticQuery(query);
  useEffect(() => {
    if (error) {
      if (!brandPageMode) {
        navigate(storeRootPath + '/error');
      }
    } else {
      // if (!loading && settingsData.filters) {
      //   setSidebarEnabled(settingsData.filters.includes('attributes'));
      // }
    }
    //eslint-disable-next-line
  }, [settings, loading, error]);
  return ___EmotionJSX("div", null, !brandPageMode ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Spacer, null), ___EmotionJSX(Heading, {
    subtitle: `${findT(data.directusProject.translations, 'de').seo_title}`
  }, title)) : ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Heading, {
    subtitle: `bei ${findT(data.directusProject.translations, 'de').seo_title}`
  }, title)), ___EmotionJSX(Filters, {
    brandPageMode: brandPageMode
  }), tag && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Spacer, {
    height: 20
  }), ___EmotionJSX(Center, null, ___EmotionJSX("p", null, "Schlagwort: ", ___EmotionJSX("b", null, tag)))), ___EmotionJSX(ProductGrid, {
    tag: tag
  }), ___EmotionJSX(Spacer, null), ___EmotionJSX(Pagination, null), ___EmotionJSX(Spacer, null));
};
export default Overview;
Overview.defaultProps = {
  brandPageMode: false
};
const query = "3756486033";